import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import SessionContext from '../../../../library/Core/SessionContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { getStudyPreferencePath } from '../../../../library/Core/SmartFunctions';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { handleCompleteLater, handleNext } from './UgEducationPreferenceActions';
import UgEducationPreferenceLayout from './UgEducationPreferenceLayout';
import OutcomeInformationLayout from '../OutcomeInformationLayout';

const UgEducationPreference = () => {
    const { globalState } = useContext(GlobalContext);
    const { sessionState } = useContext(SessionContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');
    const location = useLocation();
    const outcomeMatch = location.pathname.includes('outcome');

    const { formConfig, data, routeInfo } = useLoaderData() as State;
    const preferredPath = getStudyPreferencePath(routeInfo.id, sessionState);
    const isCorrectRoute = preferredPath.includes('ug-education-preference');

    useEffect(() => {
        if (!isCorrectRoute) {
            const suffix = outcomeMatch ? '/outcome' : '';
            navigate(`${preferredPath}${suffix}`, { replace: true });
        }
    }, []);

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: { NEXT: handleNext, I_LL_DO_THIS_LATER: handleCompleteLater, ROUTER_NAVIGATE: navigate, REDIRECT: setRedirectUrl },
    } as any);

    useEffect(() => {
        data['higherEducationPreferenceInfo'] = data['higherEducationPreferenceInfo'] || {};
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain, routeInfo },
        });
    }, []);
    
    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);
        
    const LayoutComponent = outcomeMatch ? OutcomeInformationLayout : UgEducationPreferenceLayout;

    if (!isCorrectRoute) {
        return null;
    }

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <LayoutComponent> {!state.flags.isDataLoading && <PageBuilder/>}</LayoutComponent>
        </SmartContext.Provider>
    );
};

export default UgEducationPreference;
